import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Icon } from "@me8eon/icons";
import "./page.toggle.scss";
import React from "react";
import { useAiSessionIdOps, useSessionAndMessages } from "@me8eon/sessions_messages";
import { useSearchTextFilter } from "@me8eon/all_filters";
import { useTranslation } from "@me8eon/translation";
import QuickActionLinks from "me-at-eon/src/components/ai-assist-refactored/QuickActionLinks";
import { useUserData } from "@me8eon/react_authentication";
import { ROLE_PRODUCT_TEAM_DASHBOARD } from "me-at-eon/src/pages/product-owner-dashboard/ProductOwnerDashboard.constants";

export const PageToggle = () => {
    const [query] = useSearchTextFilter();
    const [_, setSessionId] = useAiSessionIdOps();
    const [sm] = useSessionAndMessages();
    const { actualRoles } = useUserData();
    const isAdmin = localStorage.getItem("admin") === "true";
    const t = useTranslation();
    const isAiPage = window.location.pathname !== "/search-result";

    const [searchParams] = useSearchParams();
    const queryFromParam = searchParams.get("q");

    const location = useLocation();
    const navigate = useNavigate();

    const getLastUserMsg = () => {
        if (!sm) {
            const searchParams = new URLSearchParams(location.search);
            return searchParams.get("q") || "";
        }
        for (let i = sm.child.length - 1; i >= 0; i--) {
            const msg = sm.child[i];
            if (msg?.role === "user" && msg.content.trim() !== "") {
                return msg.content;
            }
        }
        return "";
    }

    const getLastActiveSessionObj = () => {
        if (!sm) return "";
        const len = sm.parent.sessions.length;
        return sm.parent.sessions[len - 2];
    }

    const getNewSearchParam = () => {
        const searchParams = new URLSearchParams(location.search);

        if (location.pathname === "/ai") {
            const lastActiveId = getLastActiveSessionObj() || null;
            if (lastActiveId?.name === queryFromParam) {
                if (sm.childId !== lastActiveId.id) {
                    setSessionId(lastActiveId.id);
                }
            }
            const lastMsg = getLastUserMsg() as string;

            if (lastMsg) {
                searchParams.set("q", lastMsg);
            }
        } else if (location.pathname === "/search-result") {
            searchParams.set("q", query);
        } else {
            return location.pathname;
        }
        return `?${searchParams.toString()}`;
    };

    const btnClick = (url: string) => {
        navigate(`${url}${url === "/tile" ? "" : getNewSearchParam()}`)
    }

    return (
        <div className="page-toggle">
            <div style={{ display: "flex", width: "100%", justifyContent: "center" }}>
                <div className="ai-toggle">
                    <ToggleButton
                        icon="AiIcon24"
                        label="Assistance"
                        onClick={() => btnClick("/ai")}
                        isActive={location.pathname === "/ai"}
                        title={t("assistantTabTooltip")}
                    />
                    <ToggleButton
                        icon="home"
                        label="Dashboard"
                        onClick={() => btnClick("/tile")}
                        isActive={location.pathname === "/tile"}
                    />
                    {isAdmin && (<div className="toggle-link">
                        <ToggleButton
                            icon="search"
                            label="E.ON Search"
                            onClick={() => btnClick("/search-result")}
                            isActive={location.pathname === "/search-result"}
                            title={t("searchTabTooltip")}
                        />
                    </div>)}
                    {actualRoles.includes(ROLE_PRODUCT_TEAM_DASHBOARD) && (
                        <ToggleButton
                            icon="dashboard_02"
                            label="Analytics"
                            onClick={() => btnClick("/analytics")}
                            isActive={location.pathname === "/analytics"}
                        />
                    )}
                    {isAiPage && (
                        <div className="quick-action" style={{ width: "44px", alignItems: "center", justifyContent: "flex-end", position: "fixed", top: "90px", right: "-4px" }}>
                            <div style={{ position: "absolute" }}>
                                <QuickActionLinks isInHeader />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

interface BtnProps {
    icon?: string,
    label: string,
    isActive?: boolean
    customStyle?: any
    onClick?: () => void,
    title?: string
}
const ToggleButton: React.FC<BtnProps> = ({ icon, label, isActive, onClick, title }) => {
    return (
        <button className={`btn ${isActive ? "btn--active" : ""}`} onClick={onClick} title={title ?? ''}>
            {icon && (<Icon name={icon} size="normal" style={{ ...(icon === "search" ? { fill: "var(--primary-color)" } : {}) }} />)}
            <span className="btn-label">{label}</span>
        </button>
    )
}